/**
 * @generated SignedSource<<541371fee94679d6c8c884b9c65fa7f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SendMarketingEmailTestEmailInput = {
  id: string;
  language?: string | null | undefined;
  recipientEmail: string;
  sampleContactIdentifier?: string | null | undefined;
};
export type SendMarketingEmailTestEmailDialogMutation$variables = {
  input: SendMarketingEmailTestEmailInput;
};
export type SendMarketingEmailTestEmailDialogMutation$data = {
  readonly sendMarketingEmailTestEmail: {
    readonly id: string;
  };
};
export type SendMarketingEmailTestEmailDialogMutation = {
  response: SendMarketingEmailTestEmailDialogMutation$data;
  variables: SendMarketingEmailTestEmailDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarketingEmail",
    "kind": "LinkedField",
    "name": "sendMarketingEmailTestEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SendMarketingEmailTestEmailDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SendMarketingEmailTestEmailDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f87b45d1ffba260556ddf58690f557f1",
    "id": null,
    "metadata": {},
    "name": "SendMarketingEmailTestEmailDialogMutation",
    "operationKind": "mutation",
    "text": "mutation SendMarketingEmailTestEmailDialogMutation(\n  $input: SendMarketingEmailTestEmailInput!\n) {\n  sendMarketingEmailTestEmail(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "576f4b3f1b07c65436b890831322cdbf";

export default node;
